import React from "react";
import DifMetStyle from "./Differential_metabolite.module.css";
import { Button, Col, Form, Input, Row, Select, Table } from "antd";
import {ReactComponent as ImgDownIcon} from '../../../assets/icon/imageDown.svg'
import Results_Colums from "./json/Diffcolums";
import Matchstick from "./Echarts/Matchstick";
import Scatter from "./Echarts/Scatter";
import Box from "./Echarts/Box";
import ViolinPlotChart from "./Echarts/ViolinPlot";
function Differential_metabolite() {


  return (
    <div className={DifMetStyle.DifMet_app}>
      <div className={DifMetStyle.Difmet_Header}>
        <p>Differential metabolite analysis</p>
      </div>
      <div className={DifMetStyle.Difmet_Form_div}>
        <div className={DifMetStyle.Difmet_Form_title}>Enrichment analysis</div>
        <Form style={{ width: "100%", marginTop: 20 }}>
          <Row>
            <Col span={8}>
              <Form.Item
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                label={
                  <span style={{ fontWeight: "bold" }}>Compared Samples</span>
                }
                name="compared_samples"
              >
                <Select
                  style={{
                    width: 250,
                  }}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                label={<span style={{ fontWeight: "bold" }}>Tissue</span>}
                name="Tissue"
              >
                <Input
                  style={{
                    width: 250,
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                label={<span style={{ fontWeight: "bold" }}>Time</span>}
                name="Time"
              >
                <Input
                  style={{
                    width: 250,
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              htmlType="submit"
              style={{ background: "#E5F0DF", border: "none" }}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className={DifMetStyle.Difmet_Results}>
        <div className={DifMetStyle.Difmet_Results_title}>
          <hr style={{ width: "45%" }} />
          <p className={DifMetStyle.Difmet_Results_title_text}>Results</p>
          <hr style={{ width: "45%" }} />
        </div>
        <div className={DifMetStyle.Difmet_Results_content}>
          <div className={DifMetStyle.Difmet_Results_content_title}>
            <p
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                margin: "10px 0",
                paddingLeft: "10px",
              }}
            >
              Metabolite differential screening results
            </p>
            <p
              style={{
                width: "100%",
                height: "20px",
                backgroundColor: "#EBFEE1",
              }}
            ></p>
          </div>
          <Table style={{width:"95%", margin: "10px auto"}}
          bordered
          columns={Results_Colums}
          />
          <div className={DifMetStyle.Difmet_Results_content_echarts}>
           
            <Scatter/>
            <Matchstick/>
            <Box/>
            <ViolinPlotChart/>
            <Matchstick/>
            <Matchstick/>
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default Differential_metabolite;
